





































































import Vue from 'vue';
import { mapState, mapMutations, mapActions } from 'vuex';
import { tConvert, convertDateToAmericanFormat, datetimeFormatToAmericanFormat } from '../../lib/utils';
import TicketCancelDialog from './TicketCancelDialog.vue';
import MarkAsUsedDialog from './MarkAsUsedDialog.vue';

export default Vue.extend({
    props: {
        userId: {
            required: true,
            type: Number,
        },
        dateRange: {
            required: true,
            type: Array,
        },
        sharedUserId: {
            type: Number,
        },
    },
    components: {
        TicketCancelDialog,
        MarkAsUsedDialog,
    },
    computed: {
        ...mapState('tickets', ['usersTickets', 'loading']),
        ...mapState('texts', ['tooltips']),
        ...mapState('corporate', ['hasHealthConsent']),
        headers(): any {
            const newHeaders = [...this.baseHeaders];
            newHeaders.splice(1, 0, {
                text: 'Status',
                value: 'ticketStatus',
                filter: (value: string): boolean => {
                    if (this.filters.ticketStatus === 'all') return true;
                    return value === this.filters.ticketStatus;
                },
            });
            return newHeaders;
        },
        tableData(): any {
            if (this.sharedUserId) {
                return this.data;
            }
            return this.usersTickets;
        },
    },
    data() {
        return {
            dialogDelete: false,
            dialogUsed: false,
            selectedTicket: { ticketId: 0 },
            filters: {
                ticketStatus: 'all',
            },
            data: [],
            baseHeaders: [] as any,
        };
    },
    methods: {
        ...mapActions('tickets', ['getTickets']),
        ...mapMutations('tickets', ['setLoading']),
        async showOnlyShared() {
            if (this.sharedUserId) {
                try {
                    this.setLoading(true);
                    this.data = [];
                    const headersToKeep = ['ticketDate', 'routeName', 'ridePlannedDeparture', 'ridePlannedArrival', 'healthConsent'];
                    this.baseHeaders = this.headers.filter((val: any) => headersToKeep.includes(val.value));
                    const result = await this.$hipApi.getUserTickets(this.sharedUserId, this.dateRange[0] as string, this.dateRange[1] as string);
                    const rideIds = result.filter((res: any) => res.rideId != null && res.ticketStatus === 'used').map((res: any) => res.rideId);
                    this.data = this.usersTickets.filter((res: any) => rideIds.includes(res.rideId) && res.ticketStatus === 'used');
                } catch (err) {
                    this.$notifier.showError(err?.error?.message || err?.message || err);
                }
                this.setLoading(false);
            }
        },
        datetimeFormatToAmericanFormat,
        tConvert,
        convertDateToAmericanFormat,
        markTicketAsUsed(item: any) {
            this.selectedTicket = item;
            this.dialogUsed = true;
        },
        cancelTicket(item: any) {
            this.selectedTicket = item;
            this.dialogDelete = true;
        },
        onTicketStatusChange() {
            this.getTickets({ userId: this.userId, dateRange: this.dateRange });
        },
        createTableHeaders() {
            this.baseHeaders = [
                {
                    text: 'Date',
                    value: 'ticketDate',
                },
                { text: 'Route', value: 'routeName' },
                {
                    text: 'Planned Departure',
                    value: 'ridePlannedDeparture',
                },
                {
                    text: 'Planned Arrival',
                    value: 'ridePlannedArrival',
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                },
            ];
            if (this.hasHealthConsent) {
                this.baseHeaders.splice(4, 0, { text: 'Health', value: 'healthConsent' });
            }
        },
    },
    watch: {
        userId() {
            if (!this.sharedUserId) {
                this.getTickets({ userId: this.userId, dateRange: this.dateRange });
            }
        },
        dateRange() {
            if (!this.sharedUserId) {
                this.getTickets({ userId: this.userId, dateRange: this.dateRange });
            }
        },
        sharedUserId() {
            if (this.sharedUserId) {
                this.showOnlyShared();
            }
        },
    },
    created() {
        this.createTableHeaders();
        if (this.sharedUserId) {
            this.showOnlyShared();
        } else {
            this.getTickets({ userId: this.userId, dateRange: this.dateRange });
            this.data = this.usersTickets;
        }
    },
});
